// ── Tekster fra temaets sprogfiler ──
// Sprog hører hjemme i locales/, ikke i denne fil.
// Se snippets/js-variables.liquid for tilgængelige nøgler.
function themeString(key, fallback) {
  var strings = window.themeVariables && window.themeVariables.strings;
  return (strings && strings[key]) || fallback;
}

// ── Skjul produktkort hvor valgt størrelse ikke er på lager ──
function getSelectedSizes() {
  const productList = document.querySelector(
    'product-list[data-size-param]'
  );

  if (!productList) return [];

  const param = productList.getAttribute('data-size-param');
  if (!param) return [];

  return new URLSearchParams(window.location.search)
    .getAll(param)
    .map(function (value) {
      return value.trim().toLowerCase();
    })
    .filter(Boolean);
}

function filterUnavailableCards() {
  const selectedSizes = getSelectedSizes();
  const productList = document.querySelector('product-list');

  if (selectedSizes.length === 0) {
    document.querySelectorAll(
      'product-card[data-available-sizes]'
    ).forEach(function (card) {
      if (!card._hiddenByGroup) {
        card.style.display = '';
      }
    });

    if (productList) {
      productList.classList.remove('filter-pending');
    }

    return;
  }

  if (productList) {
    productList.classList.add('filter-pending');
  }

  document.querySelectorAll(
    'product-card[data-available-sizes]'
  ).forEach(function (card) {
    if (card._hiddenByGroup) return;

    const sizes = card.getAttribute('data-available-sizes')
      .split(',')
      .map(function (size) {
        return size.trim();
      });

    const hasSelectedSize = selectedSizes.some(function (size) {
      return sizes.indexOf(size) !== -1;
    });

    card.style.display = hasSelectedSize ? '' : 'none';
  });

  if (productList) {
    productList.classList.remove('filter-pending');
  }
}

// ── Gruppér produktkort af samme style, men ikke i søgningen ──
// Denne del bevarer den søgeændring, som virkede.
function groupColorVariants() {
  const seen = {};

  // Matcher /search, /en/search, /de/search osv.
  const isSearchPage = /\/search\/?$/.test(
    window.location.pathname
  );

  document.querySelectorAll('product-card').forEach(function (card) {
    const isSearchSuggestion = Boolean(
      card.closest('predictive-search')
    );

    if (isSearchPage || isSearchSuggestion) {
      if (card._hiddenByGroup) {
        card.style.display = '';
      }

      card._hiddenByGroup = false;
      return;
    }

    const dots = card.querySelectorAll(
      '.product-color-swatch a[data-handle]'
    );

    if (dots.length === 0) return;

    const key = Array.from(dots)
      .map(function (dot) {
        return dot.getAttribute('data-handle').split('?')[0];
      })
      .sort()
      .join('|');

    if (seen[key]) {
      card.style.display = 'none';
      card._hiddenByGroup = true;
    } else {
      seen[key] = true;
      card._hiddenByGroup = false;
      card.style.display = '';
    }
  });
}

// ── Hent og cache produktbilleder via API ──
const _imageCache = {};

function fetchProductImages(handle) {
  const cleanHandle = handle.split('?')[0];

  if (_imageCache[cleanHandle]) {
    return Promise.resolve(_imageCache[cleanHandle]);
  }

  return fetch(
    window.Shopify.routes.root + 'products/' + cleanHandle + '.js'
  )
    .then(function (response) {
      return response.json();
    })
    .then(function (data) {
      const images = (data.images || []).map(function (src) {
        return src.startsWith('//') ? 'https:' + src : src;
      });

      _imageCache[cleanHandle] = images;
      return images;
    })
    .catch(function () {
      return [];
    });
}

// ── Prefetch farve-dot billeder ──
function prefetchAllDotImages() {
  document.querySelectorAll(
    '.product-color-swatch a[data-handle]'
  ).forEach(function (dot) {
    // Prefetch hver dot én gang, også når nye kort tilføjes.
    if (dot._imagesPrefetched) return;

    const handle = (dot.getAttribute('data-handle') || '')
      .split('?')[0];

    if (!handle) return;

    dot._imagesPrefetched = true;
    fetchProductImages(handle);
  });
}

// ── Farve-dot hover/klik på eksisterende og nye produktkort ──
function initializeColorDots() {
  document.querySelectorAll(
    '.product-color-swatch a[data-image]'
  ).forEach(function (dot) {
    // Undgå dobbelte event listeners.
    if (dot._colorDotInitialized) return;

    function toAbsolute(src) {
      if (!src) return '';
      return src.startsWith('//') ? 'https:' + src : src;
    }

    const newSrc = toAbsolute(
      dot.getAttribute('data-image')
    );

    const newSrcSec = toAbsolute(
      dot.getAttribute('data-secondary-image')
    );

    const newUrl = dot.getAttribute('data-url');
    const newHandle = dot.getAttribute('data-handle');
    const newTitle = dot.getAttribute('data-title');
    const newPrice = dot.getAttribute('data-price');
    const newCompare = dot.getAttribute('data-compare-price');

    const card = dot.closest(
      'product-card, .product-card, li, article'
    );

    if (!card) return;

    const cardImgPrimary = card.querySelector(
      'img.product-card__image--primary'
    );

    const cardImgSecondary = card.querySelector(
      'img.product-card__image--secondary'
    );

    if (!cardImgPrimary) return;

    dot._colorDotInitialized = true;

    if (!card._originalSrc) {
      card._originalSrc = cardImgPrimary.src;
      card._originalSrcset = cardImgPrimary.srcset;

      card._originalSrcSec = cardImgSecondary
        ? cardImgSecondary.src
        : null;

      card._originalSrcsetSec = cardImgSecondary
        ? cardImgSecondary.srcset
        : null;

      card._originalUrl = card.querySelector(
        'a.product-card__media'
      )?.href;

      card._originalHandle = card.querySelector(
        'quick-buy-modal'
      )?.getAttribute('handle');

      card._originalTitle = card.querySelector(
        'a.product-title'
      )?.textContent;

      const origSaleEl = card.querySelector('sale-price');
      const origCompareEl = card.querySelector('compare-at-price');

      card._originalPrice = origSaleEl
        ? origSaleEl.lastChild.textContent.trim()
        : null;

      card._originalCompare = origCompareEl
        ? origCompareEl.lastChild.textContent.trim()
        : null;
    }

    function applyDot(src, srcSec, url, handle, title, price, compare) {
      const mediaLink = card.querySelector(
        '.product-card__media[data-all-images]'
      );

      // Et sent billedsvar må ikke overskrive en nyere farve
      // eller et kort, der allerede er nulstillet.
      card._colorImageRequest = (card._colorImageRequest || 0) + 1;
      const requestId = card._colorImageRequest;

      if (handle) {
        fetchProductImages(handle).then(function (images) {
          if (card._colorImageRequest !== requestId) return;

          if (mediaLink && mediaLink._setImages) {
            mediaLink._setImages(
              src,
              images.length > 0 ? images : null
            );
          }
        });
      }

      cardImgPrimary.srcset = '';
      cardImgPrimary.src = src;

      if (cardImgSecondary && srcSec) {
        cardImgSecondary.srcset = '';
        cardImgSecondary.src = srcSec;
      }

      card.querySelectorAll(
        'a.product-card__media, a.product-title'
      ).forEach(function (link) {
        link.href = url;
      });

      const titleEl = card.querySelector('a.product-title');

      if (titleEl && title) {
        titleEl.textContent = title;
      }

      const modal = card.querySelector('quick-buy-modal');

      if (modal && handle) {
        modal.setAttribute('handle', handle);
      }

      const saleEl = card.querySelector('sale-price');
      const compareEl = card.querySelector('compare-at-price');

      if (saleEl && price) {
        saleEl.lastChild.textContent = price;
      }

      if (compareEl) {
        if (compare && compare !== price) {
          compareEl.lastChild.textContent = compare;
          compareEl.style.display = '';
        } else {
          compareEl.style.display = 'none';
        }
      }
    }

    function resetCard() {
      // Ignorér eventuelle billedsvar fra tidligere hover/klik.
      card._colorImageRequest = (card._colorImageRequest || 0) + 1;

      const mediaLink = card.querySelector(
        '.product-card__media[data-all-images]'
      );

      if (mediaLink && mediaLink._setImages) {
        mediaLink._setImages(null, null);
      }

      cardImgPrimary.src = card._originalSrc;
      cardImgPrimary.srcset = card._originalSrcset || '';

      if (cardImgSecondary && card._originalSrcSec) {
        cardImgSecondary.src = card._originalSrcSec;
        cardImgSecondary.srcset = card._originalSrcsetSec || '';
      }

      card.querySelectorAll(
        'a.product-card__media, a.product-title'
      ).forEach(function (link) {
        link.href = card._originalUrl;
      });

      const titleEl = card.querySelector('a.product-title');

      if (titleEl) {
        titleEl.textContent = card._originalTitle;
      }

      const modal = card.querySelector('quick-buy-modal');

      if (modal && card._originalHandle) {
        modal.setAttribute('handle', card._originalHandle);
      }

      const saleEl = card.querySelector('sale-price');
      const compareEl = card.querySelector('compare-at-price');

      if (saleEl && card._originalPrice) {
        saleEl.lastChild.textContent = card._originalPrice;
      }

      if (compareEl) {
        if (card._originalCompare) {
          compareEl.lastChild.textContent = card._originalCompare;
          compareEl.style.display = '';
        } else {
          compareEl.style.display = 'none';
        }
      }
    }

    dot.addEventListener('mouseenter', function () {
      if (!card._lockedDot) {
        applyDot(
          newSrc,
          newSrcSec,
          newUrl,
          newHandle,
          newTitle,
          newPrice,
          newCompare
        );
      }
    });

    dot.addEventListener('mouseleave', function () {
      if (!card._lockedDot) {
        resetCard();
      } else if (card._lockedDot !== dot) {
        const lockedDot = card._lockedDot;

        applyDot(
          toAbsolute(lockedDot.getAttribute('data-image')),
          toAbsolute(lockedDot.getAttribute('data-secondary-image')),
          lockedDot.getAttribute('data-url'),
          lockedDot.getAttribute('data-handle'),
          lockedDot.getAttribute('data-title'),
          lockedDot.getAttribute('data-price'),
          lockedDot.getAttribute('data-compare-price')
        );
      }
    });

    dot.addEventListener('click', function (event) {
      event.preventDefault();

      if (card._lockedDot === dot) {
        card._lockedDot = null;

        card.querySelectorAll(
          '.product-color-swatch a'
        ).forEach(function (colorDot) {
          colorDot.classList.remove('vr-locked');
        });

        resetCard();
      } else {
        card._lockedDot = dot;

        card.querySelectorAll(
          '.product-color-swatch a'
        ).forEach(function (colorDot) {
          colorDot.classList.remove('vr-locked');
        });

        dot.classList.add('vr-locked');

        applyDot(
          newSrc,
          newSrcSec,
          newUrl,
          newHandle,
          newTitle,
          newPrice,
          newCompare
        );
      }
    });
  });
}

// ── Produktkort: pile og swipe på eksisterende og nye kort ──
function initializeCardCarousels() {
  document.querySelectorAll(
    '.product-card__media[data-all-images]'
  ).forEach(function (mediaLink) {
    // Et initialiseret kort har allerede knapper og listeners.
    if (mediaLink._setImages) return;

    const originalImages = mediaLink.getAttribute('data-all-images')
      .split('|')
      .filter(Boolean)
      .map(function (src) {
        const cleanSrc = src.trim();
        return cleanSrc.startsWith('//')
          ? 'https:' + cleanSrc
          : cleanSrc;
      });

    if (originalImages.length < 2) return;

    const primaryImg = mediaLink.querySelector(
      'img.product-card__image--primary'
    );

    if (!primaryImg) return;

    let currentIndex = 0;
    let activeImages = originalImages.slice();
    let currentBaseSrc = primaryImg.src;

    const prevBtn = document.createElement('button');
    prevBtn.className = 'pc-arrow pc-arrow--prev';
    prevBtn.innerHTML = '&#8249;';
    prevBtn.setAttribute('aria-label', themeString('previous', 'Previous'));

    const nextBtn = document.createElement('button');
    nextBtn.className = 'pc-arrow pc-arrow--next';
    nextBtn.innerHTML = '&#8250;';
    nextBtn.setAttribute('aria-label', themeString('next', 'Next'));

    mediaLink.appendChild(prevBtn);
    mediaLink.appendChild(nextBtn);

    const dotsContainer = document.createElement('div');
    dotsContainer.className = 'pc-dots';

    function updateDots(count, activeIndex) {
      dotsContainer.innerHTML = '';

      for (let i = 0; i < count; i++) {
        const dot = document.createElement('span');

        dot.className = 'pc-dot' + (
          i === activeIndex ? ' pc-dot--active' : ''
        );

        dotsContainer.appendChild(dot);
      }
    }

    updateDots(originalImages.length, 0);
    mediaLink.appendChild(dotsContainer);

    mediaLink._setImages = function (baseSrc, images) {
      currentIndex = 0;

      if (images && images.length > 0) {
        activeImages = images;
        currentBaseSrc = baseSrc || images[0];
      } else {
        activeImages = originalImages.slice();
        currentBaseSrc = originalImages[0];
      }

      primaryImg.removeAttribute('srcset');
      primaryImg.removeAttribute('sizes');
      primaryImg.src = currentBaseSrc;

      updateDots(activeImages.length, 0);
    };

    function showImage(index) {
      currentIndex = (
        index + activeImages.length
      ) % activeImages.length;

      primaryImg.removeAttribute('srcset');
      primaryImg.removeAttribute('sizes');

      primaryImg.src = currentIndex === 0
        ? currentBaseSrc
        : activeImages[currentIndex];

      updateDots(activeImages.length, currentIndex);
    }

    prevBtn.addEventListener('click', function (event) {
      event.preventDefault();
      event.stopPropagation();
      showImage(currentIndex - 1);
    });

    nextBtn.addEventListener('click', function (event) {
      event.preventDefault();
      event.stopPropagation();
      showImage(currentIndex + 1);
    });

    let touchStartX = 0;
    let touchStartY = 0;

    mediaLink.addEventListener('touchstart', function (event) {
      touchStartX = event.touches[0].clientX;
      touchStartY = event.touches[0].clientY;
    }, { passive: true });

    mediaLink.addEventListener('touchend', function (event) {
      const dx = touchStartX - event.changedTouches[0].clientX;
      const dy = Math.abs(
        touchStartY - event.changedTouches[0].clientY
      );

      if (Math.abs(dx) > 50 && dy < 50) {
        event.preventDefault();
        event.stopPropagation();

        showImage(
          dx > 0 ? currentIndex + 1 : currentIndex - 1
        );
      }
    }, { passive: false });
  });
}

// ── Produktside: hover på VariantRobot thumbnail → skift galleri ──
function initializeVariantRobotGallery() {
  const gallery = document.querySelector(
    '.product-gallery__carousel'
  );

  if (!gallery) return;

  document.querySelectorAll(
    '.VariantRobot--ProductItem[data-images]'
  ).forEach(function (item) {
    if (item._variantGalleryInitialized) return;

    const images = item.getAttribute('data-images')
      .split('|')
      .filter(Boolean)
      .map(function (src) {
        return src.startsWith('//') ? 'https:' + src : src;
      });

    if (images.length === 0) return;

    const mainImg = gallery.querySelector(
      '.product-gallery__media img'
    );

    if (!mainImg) return;

    item._variantGalleryInitialized = true;

    item.addEventListener('mouseenter', function () {
      mainImg._originalSrc = mainImg._originalSrc || mainImg.src;
      mainImg._originalSrcset = mainImg._originalSrcset || mainImg.srcset;

      mainImg.srcset = '';
      mainImg.src = images[0];
    });

    item.addEventListener('mouseleave', function () {
      if (mainImg._originalSrc) {
        mainImg.src = mainImg._originalSrc;
        mainImg.srcset = mainImg._originalSrcset || '';
      }
    });
  });
}

// ── Initialisér kortfunktioner uden at vente på filter-debounce ──
function initializeProductCardFeatures() {
  initializeCardCarousels();
  initializeColorDots();
  prefetchAllDotImages();
}

// ── Gruppér og filtrér efter opdateringer ──
let _filterTimer = null;

function runFilters() {
  clearTimeout(_filterTimer);

  _filterTimer = setTimeout(function () {
    groupColorVariants();
    filterUnavailableCards();
  }, 800);
}

// ── Én observer pr. produktliste ──
const _observedProductLists = new WeakSet();

function observeProductList() {
  document.querySelectorAll('product-list').forEach(function (productList) {
    if (_observedProductLists.has(productList)) return;

    _observedProductLists.add(productList);

    new MutationObserver(scheduleProductCardUpdate).observe(
      productList,
      { childList: true, subtree: true }
    );
  });
}

// ── Saml DOM-opdateringer til højst én kørsel pr. frame ──
let _productCardUpdateScheduled = false;

function scheduleProductCardUpdate() {
  if (_productCardUpdateScheduled) return;

  _productCardUpdateScheduled = true;

  window.requestAnimationFrame(function () {
    _productCardUpdateScheduled = false;

    observeProductList();
    initializeProductCardFeatures();
    runFilters();
  });
}

// ── Skjul Samlinger-fanen i søgefeltet ──
function hideSearchCollectionsTab() {
  const collectionsLabel = themeString('searchCollections', '')
    .trim()
    .toLowerCase();

  if (!collectionsLabel) return;

  document.querySelectorAll('[role="tab"].h6').forEach(function (tab) {
    if (tab.textContent.trim().toLowerCase() === collectionsLabel) {
      tab.style.display = 'none';
    }
  });
}

// ── Første indlæsning og efterfølgende udskiftning af produktkort ──
function initializeCustomProductCards() {
  observeProductList();
  initializeProductCardFeatures();
  initializeVariantRobotGallery();
  hideSearchCollectionsTab();
  runFilters();

  // Fanger også nye produktlister og kort i søgeforslag.
  new MutationObserver(scheduleProductCardUpdate).observe(
    document.body,
    { childList: true, subtree: true }
  );

  const hideCollectionsTab = new MutationObserver(
    hideSearchCollectionsTab
  );

  hideCollectionsTab.observe(
    document.body,
    { childList: true, subtree: true }
  );
}

if (document.readyState === 'loading') {
  document.addEventListener(
    'DOMContentLoaded',
    initializeCustomProductCards,
    { once: true }
  );
} else {
  initializeCustomProductCards();
}

// Sikkerhedsnet ved fuld indlæsning og tilbage-navigation.
window.addEventListener('load', scheduleProductCardUpdate);
window.addEventListener('pageshow', scheduleProductCardUpdate);
window.addEventListener('popstate', scheduleProductCardUpdate);

// Geninitialisér også indhold indlæst i temaeditoren.
document.addEventListener('shopify:section:load', function () {
  initializeVariantRobotGallery();
  scheduleProductCardUpdate();
});

const _pushState = history.pushState.bind(history);

history.pushState = function () {
  const result = _pushState.apply(history, arguments);
  scheduleProductCardUpdate();
  return result;
};

// ── Gem og gendan scroll-position ved tilbage-navigation ──
(function () {
  const key = 'scroll_' + window.location.pathname;
  const savedY = sessionStorage.getItem(key);

  if (savedY) {
    window.addEventListener('load', function () {
      setTimeout(function () {
        window.scrollTo({
          top: parseInt(savedY, 10),
          behavior: 'instant'
        });

        sessionStorage.removeItem(key);
      }, 100);
    });
  }

  document.addEventListener('click', function (event) {
    const link = event.target.closest(
      'product-card a, .product-card a'
    );

    if (link) {
      sessionStorage.setItem(
        'scroll_' + window.location.pathname,
        window.scrollY
      );
    }
  });
})();
